/*************
 * findARetailer
 *
 */

custom.videoAutoplayHandler = (() => {
  // const pdpIdentifierClass = "product-detail";
  // const thumbnailsClass = "product-detail__thumbnails";
  // const imagesClass = "product-detail__images";

  // const vimeoStr = "player.vimeo.com"
  // const onPDP = $(`.${pdpIdentifierClass}`).length;

  const breakpoint = 768;

  function isMobile() {
    return $(window).width() < breakpoint;
  }

  /******************
   * FORM VALIDATION HANDLING
   */
  function play(payload = null) {
    if (!payload) return;
    if ($(payload).find('video').length) {
      //https://developer.chrome.com/blog/play-request-was-interrupted/
      var video = $(payload).find('video').get(0);
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch((error) => {
            // Auto-play was prevented
            // Show paused UI.
            video.controls = true;
          });
      }
    }
  }

  function responsiveHandler() {
    if (isMobile()) {
      const $responsiveVideo = $('video[data-src-mobile]');
      if ($responsiveVideo.length) {
        const mobileSrc = $responsiveVideo.data('src-mobile');
        $responsiveVideo.find('source').attr('src', mobileSrc);
      }
    }
  }

  function init() {
    responsiveHandler();
    // $(window).on('resize', responsiveHandler);
  }

  return {
    init,
    play,
  };
})();

custom.videoAutoplayHandler.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/video-autoplay-handler.js